import { gsap} from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const blurElement = document.querySelector('.js-scrollBlur');
  if (!blurElement) return;

  gsap.to(blurElement, {
    scrollTrigger: {
      trigger: blurElement,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
    },
    "--blur-progress": 1,
    ease: 'none',
  });
}

export {
  init
}
